export const CLIENTS_TABLE = {
    'CLIENTS.COLUMN.NAME': 'Nume',
    'CLIENTS.COLUMN.FISCAL_IDENTIFIER': 'NIF/CIF',
    'CLIENTS.COLUMN.COMPANIES.HEADER': 'Număr companii',
    'CLIENTS.COLUMN.COMPANIES.SUBHEADER': 'Active | Maxim',
    'CLIENTS.COLUMN.ROLES.HEADER': 'Roluri',
    'CLIENTS.COLUMN.ROLES.SUBHEADER': 'Activate | Maxim',
    'CLIENTS.COLUMN.USERS.HEADER': 'Număr utilizatori',
    'CLIENTS.COLUMN.USERS.SUBHEADER': 'Activi | Maxim',
    'CLIENTS.COLUMN.STORAGE.HEADER': 'GB stocare',
    'CLIENTS.COLUMN.STORAGE.SUBHEADER': 'Utilizați | Maxim',
    'CLIENTS.COLUMN.EXTRA_FEATURES': 'Extra activitate',
    'CLIENTS.COLUMN.STATUS': 'Status',
    'CLIENTS.COLUMN.DATE': 'Dată actualizare',
    'CLIENTS.COLUMN.UPDATED_BY': 'Actualizat de',
    'CLIENTS.COLUMN.ACTIONS': 'Acțiuni',
    'CLIENTS.SEARCH_PLACEHOLDER': 'Caută Nume/NIF/CIF',
    'CLIENTS.ACTION.ADD': 'Client nou',
    'CLIENTS.ACTION.EDIT': 'Editează',
    'CLIENTS.ACTION.DETAILS': 'Detalii client',
    'CLIENTS.ACTION.DELETE': 'Șterge client',
    'CLIENTS.ACTION.DEACTIVATE': 'Dezactivează acces',
    'CLIENTS.ACTION.REACTIVATE': 'Reactivează',
    'CLIENTS.ACTION.DEACTIVATE_OPERATIONS': 'Dezactivează operații',
    'CLIENTS.ACTION.RESEND_INVITATIONS': 'Retrimite invitații',
    'CLIENTS.FILTER.STATUS': 'Status',
    'CLIENTS.FILTER.EXTRA_FUNCTIONALITIES': 'Extra functionalități'
};
export const CLIENT_LOGS_TABLE = {
    'CLIENT_LOGS.COLUMN.COMPANIES.HEADER': 'Număr companii',
    'CLIENT_LOGS.COLUMN.COMPANIES.SUBHEADER': 'Active | Maxim',
    'CLIENT_LOGS.COLUMN.ROLES.HEADER': 'Roluri',
    'CLIENT_LOGS.COLUMN.ROLES.SUBHEADER': 'Activate | Maxim',
    'CLIENT_LOGS.COLUMN.USERS.HEADER': 'Număr utilizatori',
    'CLIENT_LOGS.COLUMN.USERS.SUBHEADER': 'Activi | Maxim',
    'CLIENT_LOGS.COLUMN.STORAGE.HEADER': 'GB stocare',
    'CLIENT_LOGS.COLUMN.STORAGE.SUBHEADER': 'Utilizați | Maxim',
    'CLIENT_LOGS.COLUMN.EXTRA_FEATURES': 'Extra',
    'CLIENT_LOGS.COLUMN.EXTRA_FEATURES.SUBHEADER': '<highlight>Active</highlight> | Posibile',
    'CLIENT_LOGS.COLUMN.STATUS': 'Status',
    'CLIENT_LOGS.COLUMN.REASON': 'Motiv justificativ',
    'CLIENT_LOGS.COLUMN.DATE': 'Dată actualizare',
    'CLIENT_LOGS.COLUMN.UPDATED_BY': 'Actualizat de'
};
